<template>
  <c-row>
    <div class="col-md-12">
      <petty-cash :header="true" />
    </div>
  </c-row>
</template>
<script>
import PettyCash from './components/PettyCash.vue';
export default {
  components: { PettyCash },
};
</script>